export const getFieldID = (field, index) => {
  const prefix = `inspections.${index}.`

  return `${prefix}${field}`
};
